import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ParentState } from '@pages/parents/state/parent.reducer';
import { LOCAL_STORAGE_REDUCERS } from 'src/app/configs/libraries/ngrx-redux/ngrx';

export const selectParent = createFeatureSelector<ParentState>(LOCAL_STORAGE_REDUCERS.PARENT);
export const selectTeens = createSelector(selectParent,(state: ParentState) => state?.teens);
export const selectTeenWallets = createSelector(selectParent,(state: ParentState) => state?.wallets);